import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import Button from './Button';
import { CheckCircleIcon, ArrowLeftIcon, MailIcon } from 'lucide-react';
const VerificationPage = ({
  email
}) => {
  const navigate = useNavigate();
  const [resendSuccess, setResendSuccess] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [cooldownTimer, setCooldownTimer] = useState(0);
  useEffect(() => {
    if (cooldownTimer > 0) {
      const timer = setTimeout(() => {
        setCooldownTimer(cooldownTimer - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldownTimer]);
  const handleResendEmail = () => {
    setResendLoading(true);
    setTimeout(() => {
      setResendLoading(false);
      setResendSuccess(true);
      setCooldownTimer(60); // 60 seconds cooldown
      setTimeout(() => {
        setResendSuccess(false);
      }, 3000);
    }, 1500);
  };
  const handleBackToLogin = () => {
    navigate('/');
  };
  const isResendDisabled = resendLoading || cooldownTimer > 0;
  return <AuthLayout title="Verify Your Email" data-id="element-245">
      <div className="text-center space-y-8 w-full" data-id="element-246">
        <div className="flex justify-center" data-id="element-247">
          <div className="bg-blue-100 p-5 rounded-full relative" data-id="element-248">
            <MailIcon size={50} className="text-blue-600" data-id="element-249" />
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-250">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-251">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-252"></path>
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-4" data-id="element-253">
          <h2 className="text-2xl font-semibold text-gray-800" data-id="element-254">
            Check Your Inbox
          </h2>

          <div className="bg-blue-50 p-5 rounded-xl border border-blue-200 shadow-sm" data-id="element-255">
            <p className="text-gray-600 mb-2" data-id="element-256">
              We've sent a verification email to:
            </p>
            <p className="font-medium text-blue-800 text-lg" data-id="element-257">
              {email || 'you@example.com'}
            </p>
          </div>

          <p className="text-gray-600" data-id="element-258">
            Click the link in the email to verify your account and complete the
            registration process.
          </p>
        </div>

        <div className="pt-4 space-y-5" data-id="element-259">
          {resendSuccess && <div className="flex items-center justify-center text-green-600 space-x-2 bg-green-50 p-3 rounded-lg animate-fade-in" data-id="element-260">
              <CheckCircleIcon size={20} data-id="element-261" />
              <span data-id="element-262">Email resent successfully</span>
            </div>}

          <div className="p-5 bg-blue-50 rounded-xl border border-blue-200 shadow-sm" data-id="element-263">
            <p className="text-gray-600 mb-3" data-id="element-264">Didn't receive the email?</p>
            <Button onClick={handleResendEmail} variant="outline" loading={resendLoading} disabled={isResendDisabled} fullWidth data-id="element-265">
              {cooldownTimer > 0 ? `Resend in ${cooldownTimer}s` : 'Resend verification email'}
            </Button>
          </div>

          <div className="pt-2" data-id="element-266">
            <button type="button" onClick={handleBackToLogin} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors" data-id="element-267">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-268" />
              Back to sign in
            </button>
          </div>
        </div>
      </div>
    </AuthLayout>;
};
export default VerificationPage;